import { notify } from "@helpers"

export default function useActions(
    salon: Model.Response<Interfaces.Photo[]>, 
    api: Customer.Models.Gallery.Api, 
    methods: Customer.Models.Gallery.Methods
): Customer.Models.Gallery.Actions {
    const store = getStoreAction(api, methods)

    return {
        store
    }
}

function getStoreAction(   
    api: Customer.Models.Gallery.Api, 
    methods: Customer.Models.Gallery.Methods
): Customer.Models.Gallery.Actions.Store {
    return async (image: File) => {
        const response = await api.store(image)
        methods.store(response.photo)

        if (response.message)
            notify(response.message)
            
        return response.photo
    }
}